import React from "react";
import Register from "../../components/Register/Register";

const RegisterPage = () => {
  return (
    <div className=" min-h-screen bg-gradient-to-r from-slate-200 to-slate-400 ... ">
      <br />
      <Register />
      <br/>
    </div>
  );
};

export default RegisterPage;
